import { jsxs as C, jsx as l } from "react/jsx-runtime";
import { svgIconStyles as n } from "../svg-icon/SvgIcon.styles.js";
function s({
  label: e,
  className: i,
  size: r,
  ...o
}) {
  return /* @__PURE__ */ C(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "circleCheckmarkFill",
      stroke: "none",
      role: "img",
      "aria-hidden": !e,
      focusable: "false",
      className: n({ className: i, size: r }),
      ...o,
      children: [
        e && /* @__PURE__ */ l("title", { children: e }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.6 7.20006C18.0418 7.53143 18.1314 8.15823 17.8 8.60006L11.809 16.5881C11.7957 16.6063 11.7818 16.6241 11.7672 16.6415C11.6764 16.7503 11.5668 16.8352 11.4467 16.895C11.1812 17.0273 10.8645 17.037 10.5874 16.9112C10.508 16.8753 10.4323 16.8284 10.3627 16.7707C10.333 16.7462 10.3051 16.7203 10.279 16.6932L6.29289 12.7071C5.90237 12.3166 5.90237 11.6834 6.29289 11.2929C6.68342 10.9024 7.31658 10.9024 7.70711 11.2929L10.8918 14.4776L16.2 7.40006C16.5314 6.95823 17.1582 6.86869 17.6 7.20006Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  s as CircleCheckmarkFillIcon,
  s as default
};
